function escapeVCardValue(value) {
  return String(value ?? '')
    .replace(/\\/g, '\\\\')
    .replace(/\r?\n/g, '\\n')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,');
}

function getBusinessPhones(contact) {
  if (Array.isArray(contact?.business_phones)) return contact.business_phones;
  if (typeof contact?.business_phones === 'string') {
    try {
      const parsed = JSON.parse(contact.business_phones);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}

export function buildVCard(contact, { includePhoto = false, photoBase64 = null } = {}) {
  const companyName = contact?.branding?.legalName || contact?.company_name || '';
  const website = contact?.branding?.website || '';
  const lines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${escapeVCardValue(contact?.surname)};${escapeVCardValue(contact?.given_name)};;;`,
    `FN:${escapeVCardValue(contact?.display_name)}`,
  ];

  if (companyName) lines.push(`ORG:${escapeVCardValue(companyName)}`);
  if (contact?.job_title) lines.push(`TITLE:${escapeVCardValue(contact.job_title)}`);
  if (contact?.email && !contact.email.endsWith('@mailbox-contact.local')) {
    lines.push(`EMAIL;TYPE=WORK:${escapeVCardValue(contact.email)}`);
  }
  if (contact?.mobile_phone) lines.push(`TEL;TYPE=CELL:${escapeVCardValue(contact.mobile_phone)}`);
  for (const phone of getBusinessPhones(contact)) {
    if (phone) lines.push(`TEL;TYPE=WORK:${escapeVCardValue(phone)}`);
  }
  if (contact?.street_address) {
    lines.push([
      'ADR;TYPE=WORK:',
      '',
      escapeVCardValue(contact.street_address),
      escapeVCardValue(contact.city),
      escapeVCardValue(contact.state),
      escapeVCardValue(contact.postal_code),
      escapeVCardValue(contact.country),
    ].join(';'));
  }
  if (contact?.department) lines.push(`X-DEPARTMENT:${escapeVCardValue(contact.department)}`);
  if (website) lines.push(`URL:${escapeVCardValue(website)}`);
  if (includePhoto && photoBase64) {
    lines.push(`PHOTO;ENCODING=b;TYPE=JPEG:${photoBase64}`);
  }

  lines.push('END:VCARD');
  return lines.join('\r\n');
}
